// extracted by mini-css-extract-plugin
export var aggregationCell = "_2l-f";
export var aggregationRow = "_2l-e";
export var borderlessSpinnerContainer = "_2l-2";
export var closeIcon = "_2l-7";
export var expandIcon = "_2l-8";
export var expanded = "_2l-9";
export var filterDropdown = "_2l-a";
export var filterDropdownDivider = "_2l-5";
export var filterDropdownHeader = "_2l-d";
export var filterDropdownItem = "_2l-c";
export var filterDropdownModal = "_2l-b _2l-a";
export var filterItem = "_2l-4";
export var normalCellWithAdjustableBorder = "_2l-6";
export var pinButtonContainer = "_2l-g";
export var pinIcon = "_2l-h";
export var pinIconActive = "_2l-i";
export var spinner = "_2l-0";
export var spinnerContainer = "_2l-1";
export var tableContainer = "_2l-3";
export var viewButtonContainer = "_2l-j";